/**
 * 注意gpop系统目前只有英文，所以这里直接引英文
 */

// import common from './zh-CN/common';
import common from './en-US/common';

export default {
  ...common,
};
